import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const fetchAverageRevenue = (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    year,
    search_term,
    first_name,
    last_name,
    dob,
    mobile_phone,
    city,
    state,
    zip,
    insurance_ids,
    start_age,
    end_age,
    last_visit,
    sex,
    visit_day_query_type,
    visited_last_days,
    not_visited_last_days,
    order_by,
  } = filter;

  if (account_id === 0) {
    return false;
  }

  let yearParam = year ? `&year=${year}` : "";
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let firstName = first_name ? `&first_name=${first_name}` : "";
  let lastName = last_name ? `&last_name=${last_name}` : "";
  let DOB = dob ? `&dob=${dob}` : "";
  let Phone = mobile_phone ? `&mobile_phone=${mobile_phone}` : "";
  let startAge = start_age ? `&start_age=${start_age}` : "";
  let endAge = end_age ? `&end_age=${end_age}` : "";
  let lastVisit = last_visit ? `&last_visit=${last_visit}` : "";
  let Sex = sex ? `&sex=${sex}` : "";
  let insuranceIds = "";
  if (insurance_ids?.length > 0) {
    insuranceIds = insurance_ids?.map((id) => `&insurance_ids=${id}`).join("");
  }
  let visitedLastDays = visited_last_days ? `&visited_last_days=${visited_last_days}` : ``;
  let notVisitedLastDays = not_visited_last_days ? `&not_visited_last_days=${not_visited_last_days}` : "";
  let visitDayQueryType = visited_last_days || not_visited_last_days ? `&visit_day_query_type=${visit_day_query_type}` : ``;
  let sCity = city ? `&city=${city}` : "";
  let sState = state ? `&state=${state}` : "";
  let sZip = zip ? `&zip=${zip}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  try {
    return axios.get(
      `${Config.patientServerUrl}/association/get-average-revenue-payment-list?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${yearParam}${searchParam}${firstName}${lastName}${DOB}${Phone}${startAge}${endAge}${lastVisit}${Sex}${insuranceIds}${visitDayQueryType}${visitedLastDays}${notVisitedLastDays}${sCity}${sState}${sZip}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};
